export default "__VITE_ASSET__BwJXaNw9__"